<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row d-flex justify-content-between align-items-center mb-3">
      <div class="col-10 d-flex align-items-center">
        <h6 class="m-0 text-white d-flex align-items-center">
          Terms and Conditions Colors
          <i
            class="mdi mdi-information-outline font-size-16 ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Allow Stick Note to show on bottom right of Channel Posts"
          ></i>
        </h6>
      </div>
    </div>
    <div class="row">

      <div *ngIf="enableBg" [ngClass]="enableBg? 'col-4': 'col-6'">
        <label
          for="text-color"
          class="text-white w-100"
          style="text-align: left"
        >
          BG Color
        </label>
        <div
          class="input-group offcanvas-border-primary border rounded-2"
          title="Using format option"
        >
          <input
            type="text"
            id="text-color"
            class="form-control input-lg offcanvas-primary border-0"
            (change)="buttonBgColor('background',$event, true)"
            [value]="bgColor"
            />
          <span
            class="input-group-text p-1 bg-transparent border-0 offcanvas-primary"
               >
            <span
              class="input-group-text colorpicker-input-addon h-100"
              [cpOutputFormat]="'hex'"
              [style.background]="bgColor"
              [(colorPicker)]="bgColor"
              [cpPosition]="'bottom-left'"
              (colorPickerChange)="buttonBgColor('background',$event,false)"
              >
            </span>
          </span>
        </div>
      </div>

      <div [ngClass]="enableBg? 'col-4': 'col-6'" >
        <label
          for="text-color"
          class="text-white w-100"
          style="text-align: left"
        >
          Text Color
        </label>
        <div
          class="input-group offcanvas-border-primary border rounded-2"
          title="Using format option"
        >
          <input
            type="text"
            id="text-color"
            class="form-control input-lg offcanvas-primary border-0"
            (change)="buttonBgColor('text',$event, true)"
            [value]="textColor"
           />
          <span
            class="input-group-text p-1 bg-transparent border-0 offcanvas-primary"
               >
            <span
              class="input-group-text colorpicker-input-addon h-100"
              [cpOutputFormat]="'hex'"
              [style.background]="textColor"
              [(colorPicker)]="textColor"
              [cpPosition]="'bottom-left'"
              (colorPickerChange)="buttonBgColor('text',$event, false)"

            >
            </span>
          </span>
        </div>
      </div>

      <div [ngClass]="enableBg? 'col-4': 'col-6'">
        <label
          for="text-color"
          class="text-white w-100"
          style="text-align: left"
        >
          Link Color
        </label>
        <div
          class="input-group offcanvas-border-primary border rounded-2"
          title="Using format option"
        >
          <input
            type="text"
            id="text-color"
            class="form-control input-lg offcanvas-primary border-0"
            (change)="buttonBgColor('link',$event,true)"
            [value]="linkColor"
            />
          <span
            class="input-group-text p-1 bg-transparent border-0 offcanvas-primary"
               >
            <span
              class="input-group-text colorpicker-input-addon h-100"
              [cpOutputFormat]="'hex'"
              [style.background]="linkColor"
              [(colorPicker)]="linkColor"
              [cpPosition]="'bottom-left'"
              (colorPickerChange)="buttonBgColor('link',$event, false)"
              >
            </span>
          </span>
        </div>
      </div>



    </div>
  </div>
</div>
